import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import CallButton from "./ui/CallButton";
import DirectionsButton from "./ui/DirectionsButton";
import BusinessHours from "./ui/BusinessHours";

const repairServiceLinks = [
  { to: "/auto-repair", label: "Auto Repair" },
  { to: "/check-engine-light", label: "Check Engine Light" },
  { to: "/transmission-repair", label: "Transmission Repair" },
  { to: "/european-auto-repair", label: "European Auto Repair" },
  { to: "/land-rover-repair", label: "Land Rover Repair" },
  { to: "/jaguar-repair", label: "Jaguar Repair" },
];

const socialIconClass =
  "text-slate-300 transition duration-200 ease-in-out hover:-translate-y-0.5 hover:text-teal-500 motion-reduce:hover:translate-y-0";

const Footer = () => {
  return (
    <footer className="relative z-40 w-full border-t border-white/10 bg-navy-900 text-white">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-teal-600/35 to-transparent"
        aria-hidden
      />

      <div className="mx-auto max-w-6xl px-6 py-10 sm:py-12 lg:py-14">
        <div className="grid gap-10 sm:gap-12 lg:grid-cols-12 lg:gap-10">
          {/* Connect */}
          <div className="text-center lg:col-span-4 lg:text-left">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
              Connect
            </p>
            <div className="mt-4 flex justify-center gap-7 lg:justify-start">
              <a
                href="https://www.facebook.com/profile.php?id=61573424138548"
                target="_blank"
                rel="noopener noreferrer"
                className={socialIconClass}
                aria-label="Facebook"
              >
                <FaFacebook size={22} />
              </a>
              <a
                href="https://www.instagram.com/advautosmog/"
                target="_blank"
                rel="noopener noreferrer"
                className={socialIconClass}
                aria-label="Instagram"
              >
                <FaInstagram size={22} />
              </a>
              <a
                href="https://www.linkedin.com/in/edgar-depaz-3ba172353/"
                target="_blank"
                rel="noopener noreferrer"
                className={socialIconClass}
                aria-label="LinkedIn"
              >
                <FaLinkedin size={22} />
              </a>
            </div>
          </div>

          {/* Repair services */}
          <nav
            className="text-center lg:col-span-4 lg:text-left"
            aria-label="Repair services"
          >
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
              Repair services
            </p>
            <ul className="mt-4 flex flex-col gap-2.5 sm:mx-auto sm:inline-flex sm:flex-col sm:items-center lg:mx-0 lg:items-start">
              {repairServiceLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-sm text-slate-200 no-underline transition duration-200 ease-in-out hover:text-teal-500 hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2 focus-visible:ring-offset-navy-900"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Hours + CTAs */}
          <div className="w-full max-w-md justify-self-center text-left sm:max-w-lg lg:col-span-4 lg:max-w-none lg:justify-self-end">
            <BusinessHours
              compact
              tone="dark"
              className="border-white/15 bg-white/[0.06] text-white"
            />
            <div className="mt-5 flex flex-col gap-2.5 sm:flex-row sm:flex-wrap sm:justify-center lg:justify-start lg:gap-3">
              <CallButton className="w-full justify-center px-6 py-2.5 text-sm sm:w-auto sm:min-w-[9.5rem]" />
              <DirectionsButton className="w-full justify-center border-white/35 bg-transparent px-6 py-2.5 text-sm text-white hover:border-white hover:bg-white hover:text-navy-900 sm:w-auto sm:min-w-[9.5rem]" />
            </div>
          </div>
        </div>

        <div
          className="my-8 h-px w-full bg-gradient-to-r from-transparent via-white/15 to-transparent"
          aria-hidden
        />

        <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left">
          <p className="text-sm font-medium text-white">
            &copy; 2026 Advanced Automotive Smog. All rights reserved.
          </p>
          <p className="text-sm text-slate-400">
            Handcrafted by{" "}
            <a
              href="https://devmintstudios.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-teal-500 no-underline transition duration-200 ease-in-out hover:text-teal-600 hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2 focus-visible:ring-offset-navy-900"
            >
              Devmint Studios
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
